import React from "react";
import { classNames } from "../../utilities/helpers.js";
import s from "./Button.module.css";
const ButtonGroup = (props) => {
    const { children, className, attributes } = props;
    const groupClassNames = classNames(s.group, className);
    return (React.createElement("div", { ...attributes, className: groupClassNames, role: "group" }, children));
};
export default ButtonGroup;
